// PRIMEGLOBE service catalog + pricing preview (mirrors backend)
// Single source of truth for frontend display & live quote.

export const SERVICES = [
  { id: "apartment", label: "Apartment Cleaning", blurb: "Studios to 5BR+ apartments", icon: "fa-building" },
  { id: "house", label: "House Cleaning", blurb: "Residential houses, 2-6+ bedrooms", icon: "fa-house" },
  { id: "family_house", label: "Family House Cleaning", blurb: "Large family homes by sqft", icon: "fa-house-chimney" },
  { id: "office", label: "Office Cleaning", blurb: "Commercial offices of any size", icon: "fa-briefcase" },
  { id: "restaurant", label: "Restaurant Cleaning", blurb: "Kitchens, dining, back alley", icon: "fa-utensils" },
  { id: "school", label: "School Cleaning", blurb: "Classrooms, sanitization", icon: "fa-graduation-cap" },
  { id: "pressure_washing", label: "Pressure Washing", blurb: "Driveways, walls, exteriors", icon: "fa-spray-can-sparkles" },
  { id: "junk_removal", label: "Junk Removal", blurb: "Debris, heavy haul-away", icon: "fa-dumpster" },
  { id: "medical_disinfection", label: "Medical Sanitation", blurb: "Medical-grade disinfection", icon: "fa-hospital" },
  { id: "windows", label: "Window Cleaning", blurb: "Interior, exterior, storefront", icon: "fa-window-maximize" },
  { id: "carpet", label: "Carpet & Upholstery", blurb: "Sofas, rugs, mattresses", icon: "fa-couch" },
  { id: "post_construction", label: "Post-Construction", blurb: "After-renovation deep clean", icon: "fa-helmet-safety" },
  { id: "move", label: "Move-In / Move-Out", blurb: "Full turnover cleaning", icon: "fa-truck-ramp-box" },
];

export const CONDITIONS = [
  { id: "standard", label: "Standard", hint: "Regular upkeep" },
  { id: "medium", label: "Medium", hint: "Some buildup (+10%)" },
  { id: "heavy", label: "Heavy", hint: "Deep grime (+20%)" },
  { id: "extreme", label: "Extreme", hint: "Manual quote (+40%)" },
];

export const URGENCY_OPTIONS = [
  { id: "regular", label: "Regular scheduling" },
  { id: "same_day", label: "Same-day (+20%)" },
  { id: "after_hours", label: "After-hours (+15%)" },
  { id: "holiday", label: "Holiday (+25%)" },
];

export const ADDONS_CATALOG = {
  kitchen: [
    { id: "oven", label: "Oven deep clean", price: 50 },
    { id: "fridge", label: "Fridge inside", price: 45 },
    { id: "microwave", label: "Microwave", price: 20 },
    { id: "hood", label: "Hood / filter", price: 35 },
    { id: "cabinets_inside", label: "Cabinets (inside)", price: 55 },
    { id: "cabinets_inside_outside", label: "Cabinets (inside + out)", price: 90 },
    { id: "dishes", label: "Dish washing / organizing", price: 40 },
  ],
  home: [
    { id: "laundry", label: "Laundry", price: 35 },
    { id: "inside_windows", label: "Inside windows", price: 40 },
    { id: "balcony", label: "Balcony / patio", price: 45 },
    { id: "garage", label: "Garage", price: 60 },
    { id: "basement", label: "Basement", price: 80 },
    { id: "sanitizing", label: "Sanitizing treatment", price: 120 },
  ],
  pressure: [
    { id: "mold_treatment", label: "Mold treatment", price: 200 },
    { id: "chemical_wash", label: "Chemical wash", price: 150 },
  ],
  windows: [
    { id: "track_cleaning", label: "Track cleaning (per window)", price: 4 },
    { id: "screen_cleaning", label: "Screen cleaning (per window)", price: 4 },
    { id: "hard_water_removal", label: "Hard water removal (per window)", price: 12 },
  ],
};

export const PHOTO_REQUIRED = new Set([
  "family_house", "restaurant", "pressure_washing", "junk_removal",
  "post_construction", "medical_disinfection",
]);

// Option lists for Step 2 forms, per service
export const SIZE_OPTIONS = {
  apartment: [
    { id: "studio", label: "Studio" },
    { id: "1br", label: "1 Bedroom" },
    { id: "2br", label: "2 Bedroom" },
    { id: "3br", label: "3 Bedroom" },
    { id: "4br", label: "4 Bedroom" },
    { id: "5br+", label: "5+ Bedroom" },
  ],
  house: [
    { id: "2br", label: "2 Bedroom" },
    { id: "3br", label: "3 Bedroom" },
    { id: "4br", label: "4 Bedroom" },
    { id: "5br", label: "5 Bedroom" },
    { id: "6br+", label: "6+ Bedroom" },
  ],
  family_house: [
    { id: "<=2000", label: "Up to 2,000 sqft" },
    { id: "2000-3000", label: "2,000 – 3,000 sqft" },
    { id: "3000-4000", label: "3,000 – 4,000 sqft" },
    { id: "4000+", label: "4,000+ sqft (manual quote)" },
  ],
  office: [
    { id: "small", label: "Small office" },
    { id: "medium", label: "Medium office" },
    { id: "large", label: "Large office" },
  ],
  school: [
    { id: "small", label: "Small campus" },
    { id: "medium", label: "Medium campus" },
    { id: "large", label: "Large campus" },
  ],
  medical_disinfection: [
    { id: "small", label: "Small area" },
    { id: "medium", label: "Medium area" },
    { id: "large", label: "Large area" },
  ],
  post_construction: [
    { id: "small", label: "Small project" },
    { id: "medium", label: "Medium project" },
    { id: "large", label: "Large project" },
    { id: "xl", label: "Extra-large project" },
  ],
  move: [
    { id: "studio", label: "Studio" },
    { id: "1br", label: "1 Bedroom" },
    { id: "2br", label: "2 Bedroom" },
    { id: "3br", label: "3 Bedroom" },
    { id: "4br+", label: "4+ Bedroom" },
  ],
};

export const RESTAURANT_SECTIONS = [
  { id: "front_area", label: "Front area" },
  { id: "dining_restrooms", label: "Dining + restrooms" },
  { id: "kitchen_deep", label: "Kitchen deep clean" },
  { id: "heavy_grease_kitchen", label: "Heavy-grease kitchen" },
  { id: "full_standard", label: "Full restaurant (standard)" },
  { id: "full_deep", label: "Full restaurant (deep)" },
  { id: "back_alley", label: "Back alley / trash area" },
];

export const PRESSURE_SUB = [
  { id: "driveway", label: "Driveway" },
  { id: "sidewalk", label: "Sidewalk" },
  { id: "patio", label: "Patio" },
  { id: "exterior_wall_small", label: "Exterior wall (small)" },
  { id: "1000-1500", label: "1,000 – 1,500 sqft" },
  { id: "1500-2000", label: "1,500 – 2,000 sqft" },
  { id: "2000-2500", label: "2,000 – 2,500 sqft" },
  { id: "2500-3000", label: "2,500 – 3,000 sqft" },
  { id: "3000+", label: "Over 3,000 sqft (manual quote)" },
];

export const JUNK_LOADS = [
  { id: "small", label: "Small load – $150" },
  { id: "small_medium", label: "Small-medium – $250" },
  { id: "medium", label: "Medium load – $420" },
  { id: "large", label: "Large load – $580" },
  { id: "full_truck", label: "Full truck – $720" },
  { id: "construction", label: "Construction debris" },
];

export const WINDOW_TYPES = [
  { id: "small_interior", label: "Small — interior ($7)" },
  { id: "small_exterior", label: "Small — exterior ($9)" },
  { id: "small_both", label: "Small — both sides ($14)" },
  { id: "large_interior", label: "Large — interior ($10)" },
  { id: "large_exterior", label: "Large — exterior ($14)" },
  { id: "large_both", label: "Large — both sides ($22)" },
  { id: "storefront", label: "Storefront / facade (~$35)" },
];

export const CARPET_ITEMS = [
  { id: "room", label: "Room carpet", price: 75 },
  { id: "sofa_2seat", label: "Sofa (2-seat)", price: 90 },
  { id: "sofa_3seat", label: "Sofa (3-seat)", price: 120 },
  { id: "sectional", label: "Sectional", price: 180 },
  { id: "chair", label: "Armchair", price: 45 },
  { id: "mattress", label: "Mattress", price: 90 },
  { id: "rug_small", label: "Small rug", price: 60 },
  { id: "rug_large", label: "Large rug", price: 110 },
];

// Which add-on groups apply to which service
export const ADDON_GROUPS_FOR_SERVICE = {
  apartment: ["kitchen", "home"],
  house: ["kitchen", "home"],
  family_house: ["kitchen", "home"],
  office: ["home"],
  restaurant: ["kitchen"],
  school: ["home"],
  pressure_washing: ["pressure"],
  junk_removal: [],
  medical_disinfection: ["home"],
  windows: ["windows"],
  carpet: [],
  post_construction: ["home"],
  move: ["kitchen", "home"],
};

// Which services ask a "floors" question
export const FLOORS_APPLICABLE = new Set([
  "house", "family_house", "office", "school", "post_construction", "pressure_washing",
]);
